<div class="create-circuit">
  <div class="loader" *ngIf="isLoading">
    <app-loading-spinner></app-loading-spinner>
  </div>
  <div class="header-create">
    <div class="title">
      {{ pageTitle }}
    </div>
    <div class="subtitle">
      Étape 1 / 5
    </div>
  </div>
  <div class="breadcrumb">
    <li>
      <a class="active">
        Information sur le circuit >
      </a>
    </li>
    <li>
      <a (click)="createRoute('fr_FR', title, 2, description, youtube)" [ngClass]="{'disabled' : !title}">
        Ajoutez vos points >
      </a>
    </li>
    <li>
      <a (click)="createRoute('fr_FR', title, 3, description, youtube)" [ngClass]="{'disabled' : !canNavigate}">
        Configurez vos points >
      </a>
    </li>
    <li>
      <a (click)="createRoute('fr_FR', title, 4, description, youtube)" [ngClass]="{'disabled' : !canNavigate || !checkAllPointsConfigured}">
        Vérifiez vos points >
      </a>
    </li>
    <li>
      <a (click)="createRoute('fr_FR', title, 5, description, youtube)" [ngClass]="{'disabled' : !canNavigate || !checkAllPointsConfigured}">
        Validation
      </a>
    </li>
  </div>
  <div class="content">
    <div class="champs">
      <div class="explication">
        Vous pouvez enregistrer l'ensemble des informations de votre parcours sur cet écran.
        <br>
        Vous n'avez pas toutes les informations ? Pas de problème, vous pourrez y revenir !
      </div>
      <div class="form">
        <div class="input">
          <input
            type="text"
            placeholder="Nom du circuit *"
            [(ngModel)]="title"
            />
        </div>
        <div class="textarea">
          <textarea
            placeholder="Description du circuit"
            [(ngModel)]="description"
            rows="5"
          ></textarea>
        </div>
        <div class="medias">
          <div class="title">
            Images de la bannière du haut
          </div>
          <div class="subtitle">
            Préférez des images rectangulaires d'une largeur minimal de 1000px
          </div>
          <div class="custom-dropzone" ngx-dropzone [accept]="'image/*'" (change)="onSelect($event)">
          	<ngx-dropzone-label>
          		<div class="label">Glissez ou cliquez pour déposer des images</div>
          	</ngx-dropzone-label>
          	<ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of files" [file]="f" [removable]="true" (removed)="onRemove(f)">
          		<ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
          	</ngx-dropzone-image-preview>
          </div>
        </div>
        <div class="video">
          <div class="title">
            Vidéo de la bannière
          </div>
          <div class="subtitle">
            Vous pouvez ajouter une vidéo youtube qui se lance au clic sur la bannière. Cette option est totalement facultative.
          </div>
          <input
            type="text"
            placeholder="Lien de la vidéo youtube"
            [(ngModel)]="youtube"
            />
        </div>
      </div>
    </div>
    <div class="previsualisation">
      <div class="previ">
        PRÉVISUALISATION
      </div>
      <div class="text">
        Prévisualisation en temps reel
      </div>
    </div>
  </div>
  <div class="boutons-change">
    <div class="bouton-next">
      <a (click)="createRoute('fr_FR', title, 2, description, youtube)" [ngClass]="{'disabled' : !title}">
        Suivant >>
      </a>
    </div>
  </div>
</div>
